import {useEffect, useRef} from "react";
import {useDispatch} from "react-redux";

import {Map} from "ol";

import {createLayers, createView, logMapDebug, registerCRSs} from "../util/maps";

// Register EPSG:31467 and EPSG:3857 once on loading of this module
registerCRSs();

/**
 * Displays a Minimap centered on the geographical center of Germany
 * React Hook to use a OL Map.
 * @param {MutableRefObject<HTMLDivElement|null>} mapDivRef ref to the DIV containing the map
 * @param {MapModel} mapModel map model describing the properties of the map
 * @return {MutableRefObject<Map|null>} reference for map
 */
function useOpenLayersMap(mapDivRef, mapModel) {
    /** @type {MutableRefObject<Map|null>} */
    const mapRef = useRef(null);
    const dispatch = useDispatch();
    useEffect(() => {
        if (mapModel) {
            if (!mapRef.current) {
                // Create new map
                const map = new Map({
                    target: mapDivRef.current || undefined,
                    layers: [],
                    controls: [],
                    interactions: [],
                    // View immer zentrieren auf die geometrische Mitte von Deutschland
                    view: createView({...mapModel.view, lat: 51.05336, lon: 10.372075}),
                });

                createLayers(map, dispatch, mapModel.layers);
                mapRef.current = map;
                logMapDebug(`Created new MiniMap (target=${mapDivRef.current}):`, map);
            }
        }
    }, [mapModel, mapDivRef, dispatch]);

    return mapRef;
}

/**
 * OpenLayer MiniMap component.
 * @param {MapModel|null} model the map model describing the layers
 * @return {JSX.Element|null}
 */
function OpenLayersMiniMap({model}) {
    /** @type {MutableRefObject<HTMLDivElement|null>} */
    const mapDivRef = useRef(null);
    useOpenLayersMap(mapDivRef, model);
    if (!model) return null;
    return <div ref={mapDivRef} className="OpenLayersMiniMap"></div>;
}

export default OpenLayersMiniMap;
